import Swal from "sweetalert2";

const showCustomAlert = (
  type = "success",
  message = "OTP sent successfully",
  navigate = null,
  redirectTo = null
) => {
  return new Promise((resolve) => {
    let title = "🎉 Success!";
    let icon = "success";

    if (type === "error") {
      title = "❌ Error!";
      icon = "error";
    }

    if (type === "warning") {
      title = "⚠️ Warning!";
      icon = "warning";
    }

    Swal.fire({
      toast: true,
      position: "bottom-end", // ✅ bottom right
      width: "380px",
      background: "#101610",
      color: "#ffffff",
      icon,
      title,
      text: message,
      showConfirmButton: false,
      timer: 2000,
      timerProgressBar: true,

      didOpen: (toast) => {
        // 🔥 thoda sa aur RIGHT
        toast.style.right = "10px";   // default ~20px hota hai
        toast.style.bottom = "20px";
      },

      didClose: () => {
        if (navigate && redirectTo) {
          navigate(redirectTo);
        }
        resolve(true);
      },
    });
  });
};

export default showCustomAlert;